import { Box } from '@mui/material';
import { Hero } from './hero';
import { SmartwashDifference } from './partials/difference';
import { CleanSection } from './partials/cleanSection';
import { SelfService } from './partials/SelfService';
import { MoreInformation } from './more-info';
import { Locations } from './locations';
import { WhyChooseUs } from './partials/whyChoose';
import { DiscoverSection } from './partials/Discover';
import { FAQs } from './partials/Faq';
import { Helmet } from 'react-helmet-async';


const homeSchema: object = {
   "@context": "https://schema.org",
   "@type": "DryCleaningOrLaundry",
   "name": "E-SmartWash Laundromat",
   "image": "https://www.e-smartwash.co.nz/logo192.png",
   "@id": "https://www.e-smartwash.co.nz/#",
   "url": "https://www.e-smartwash.co.nz/",
   "telephone": "022-529-7734",
   "priceRange": "$",
   "address": {
      "@type": "PostalAddress",
      "streetAddress": "5/5 Peachgrove Road, Hamilton East",
      "addressLocality": "Hamilton",
      "postalCode": "3216",
      "addressCountry": "NZ"
   },
   "geo": {
      "@type": "GeoCoordinates",
      "latitude": -38.9492338,
      "longitude": 153.8050406
   },
   "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
         "Monday",
         "Tuesday",
         "Wednesday",
         "Thursday",
         "Friday",
         "Saturday",
         "Sunday"
      ],
      "opens": "09:00",
      "closes": "22:00"
   }
};

export const Home = () => {
   return (
      <>
         <Helmet>
            <script type="application/ld+json">
               {JSON.stringify(homeSchema, null, 2)}
            </script>

         </Helmet>
         <Box>
            <Hero />
            <SmartwashDifference />
            <SelfService />
            <CleanSection />
            <WhyChooseUs />
            <DiscoverSection />
            <MoreInformation />
            <Locations />
            <FAQs />
         </Box>
      </>
   );
};
